import { Box, Divider, Typography } from '@mui/material';

export const MobileSectionTitle = ({
  title,
  icon,
  children,
}: {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      {/* Title with Icon */}
      <Box
        sx={{
          backgroundColor: 'rgba(0, 71, 186, 0.08)',
          height: '56px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingX: '16px',
          paddingY: '8px',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px', width: '100%' }}>
          {/* Icon */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '24px',
              height: '24px',
              flexShrink: 0,
            }}
          >
            {icon}
          </Box>

          {/* Title */}
          <Box sx={{ flex: 1 }}>
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: 400,
                lineHeight: '24px',
                letterSpacing: '0.5px',
                color: '#1A1C20',
                fontFamily: '"Noto Sans JP", sans-serif',
              }}
            >
              {title}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Divider */}
      <Divider sx={{ borderColor: '#C4C6D0' }} />

      {/* Content */}
      <Box
        sx={{
          paddingX: '16px',
          paddingY: '12px',
          display: 'flex',
          flexDirection: 'column',
          gap: 0,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
